class QuantitySelector extends HTMLElement {
    constructor() {
        super();

        this.quantityDecreaseButton = this.querySelector('.js-quantity-decrease');
        this.quantityIncreaseButton = this.querySelector('.js-quantity-increase');
        this.quantityValue = this.querySelector('.js-quantity-value');
        this.maxQuantity = parseInt(this.quantityValue.getAttribute('max'));
    }

    connectedCallback() {
        this.#initListeners();
    }

    #initListeners() {
        this.quantityDecreaseButton.addEventListener('click', this.#handleQuantityDecrease.bind(this));
        this.quantityIncreaseButton.addEventListener('click', this.#handleQuantityIncrease.bind(this));
    }

    #handleQuantityDecrease() {
        if (parseInt(this.quantityValue.value) > 1) {
            this.quantityValue.value = parseInt(this.quantityValue.value) - 1;
            this.#updateQuantityButtons();
        }
    }

    #handleQuantityIncrease() {
        if (parseInt(this.quantityValue.value) < this.maxQuantity) {
            this.quantityValue.value = parseInt(this.quantityValue.value) + 1;
            this.#updateQuantityButtons();
        }
    }

    #updateQuantityButtons() {
        this.quantityDecreaseButton.disabled = parseInt(this.quantityValue.value) <= 1;
        this.quantityIncreaseButton.disabled = parseInt(this.quantityValue.value) >= this.maxQuantity;
    }
}

customElements.define('quantity-selector', QuantitySelector);